import { ChainId, Token } from '@xterswap/sdk-core'

export const XTER = {
  [ChainId.BNB]: new Token(ChainId.BNB, '0x103071Da56e7cD95b415320760D6a0dDC4DA1ca5', 18, 'XTER', 'Xterio'),
  [ChainId.XTERIO]: new Token(ChainId.XTERIO, '0xefd4bC9afD210517803f293ABABd701CaeeCdfd0', 18, 'XTER', 'Xterio'),
  [ChainId.XTERIO_TESTNET]: new Token(
    ChainId.XTERIO_TESTNET,
    '0x579B9F7967215af340Eb7e5c27EDaFcD6edc649f',
    18,
    'XTER',
    'Xterio'
  ),
}
export const USDT = {
  [ChainId.BNB]: new Token(ChainId.BNB, '0x55d398326f99059fF775485246999027B3197955', 18, 'USDT', 'Tether USD'),
  [ChainId.XTERIO]: new Token(ChainId.XTERIO, '0x4eB4512e0278f6306599Dd9038cFAdAD8Cd87b90', 18, 'USDT', 'Tether USD'),
  [ChainId.XTERIO_TESTNET]: new Token(
    ChainId.XTERIO_TESTNET,
    '0x543f95Cb5cb5b97D6272308497a33BdeC3d9FD5a',
    18,
    'USDT',
    'Tether USD'
  ),
}
